/* istanbul ignore file */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, useConfig } from '@elparking/components'
import { Login } from '@elparking/login'
import Form from 'commons/js/components/LoginBookingProcess'
import { Events } from 'commons/js/services/analytics'
import KeycloakLogin from 'commons/js/components/KeycloakLogin'
import { sendCheckTOS } from 'commons/js/services/sendMessage'

const LoginForm = ({
    loginComponent: LoginComponent,
    trackEvent,
    login,
    onLogin,
    isLoading,
    email,
    onNavigation,
}) => {
    const application = useConfig('tradename').trim().toLowerCase()
    const { keycloak, flavor } = useConfig()
    const [ intent, updateIntent ] = useState(0)
    if (isLoading) {
      return null
    }
    return <LoginComponent
      login={login}
      onLogin={(token) => onLogin(token)}
      renderForm={({ onLoginSuccess, ...restProps }) => <Box>
          {keycloak
            ? <KeycloakLogin
                {...restProps}
                keycloakConfig={keycloak}
                theme={flavor}
                key={`keycloak_form_${intent}`}
                simple
                onLoginSuccess={(_user, data) => {
                onLogin(data)
                updateIntent(intent + 1)
                sendCheckTOS()
              }}
                onNavigation={onNavigation}
                trackEvent={trackEvent}
                loginEventName={Events.bookingProcessLogin}
            />
            : <Form
                email={email}
                trackEvent={trackEvent}
                application={application}
                loginEventName={Events.bookingProcessLogin}
                onLoginSuccess={onLoginSuccess}
                {...restProps}
            />}
      </Box>}
    />
}

LoginForm.defaultProps = {
    loginComponent: Login,
    onNavigation: () => {},
    trackEvent: () => {},
}

LoginForm.propTypes = {
    loginComponent: PropTypes.elementType,
    trackEvent: PropTypes.func.isRequired,
    login: PropTypes.func.isRequired,
    onNavigation: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    email: PropTypes.string,
    isLoading: PropTypes.bool,
    fetchUser: PropTypes.func,
}

export default LoginForm
